import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import TaxDocuments from './TaxDocuments';

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TaxDocuments));
